module.exports = __webpack_public_path__ + "static/media/madhucon7.5b364c58.png";